import { useEffect } from 'react';
import styles from './ActivityFeed.module.scss';
import { ActivityFeedModal } from './ActivityFeedModal/ActivityFeedModal';
import { Icon } from 'components/Icon/Icon';
import { NoContent } from 'components/NoContent/NoContent';
import { PatientList } from 'components/PatientList/PatientList';
import { Text } from 'components/Text/Text';
import { useDevice } from 'hooks';
import {
  selectActivityFeed,
  selectActivityFeedFilter,
  selectActivityFeedInfo,
  selectActivityFeedIsLoading,
} from 'store/patients/selectors';
import { patientsActions } from 'store/patients/slice';
import { useSelector } from 'store/utils';

type Props = {
  onClose(): void;
};

export const ActivityFeed = ({ onClose }: Props) => {
  const { isTablet } = useDevice();

  const isLoading = useSelector(selectActivityFeedIsLoading);

  useEffect(() => {
    if (!isTablet) return;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  const feed = useSelector(selectActivityFeed);

  const feedContent = feed.length ? (
    <div className={styles.notificationsWrapper}>
      <PatientList
        patients={feed}
        selectFilter={selectActivityFeedFilter}
        selectInfo={selectActivityFeedInfo}
        setFilter={patientsActions.setActivityFeedFilter}
        isLoading={isLoading}
        markSelected={false}
      />
    </div>
  ) : (
    <div className={styles.noContentWrapper}>
      <NoContent pageKey="activityFeedList" />
    </div>
  );

  return isTablet ? (
    <ActivityFeedModal onClose={onClose}>
      <div className={styles.modalContent}>{feedContent}</div>
    </ActivityFeedModal>
  ) : (
    <div className={styles.container}>
      <div className={styles.header}>
        <Text type="h5">All notifications</Text>
        <Icon name="Close" onClick={onClose} />
      </div>
      {feedContent}
    </div>
  );
};
